import { api } from "../Apis/interceptor";

export const all = function (customer_id, sortBy, orderBy) {
  return api.get("/api/v1/tools/" + customer_id + "/" + sortBy + "/" + orderBy);
};

export const create = function (toolData) {
  return api.post("/api/v1/tools/", toolData);
};

export const filter = function (
  skip,
  limit,
  cust_id,
  pattern,
  sortBy,
  orderBy
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/tool_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      pattern: pattern,
      sortBy: sortBy,
      orderBy: orderBy,
    },
  });
};

export const delete1 = function (id) {
  return api.delete("/api/v1/tools/" + id);
};

export const getPageLike = function (pattern, cust_id, sortBy, orderBy) {
  return api.get(
    "/api/v1/toolLike/" + pattern + "/" + cust_id + "/" + sortBy + "/" + orderBy
  );
};

export const multiDelete = function (ids) {
  return api.delete("/api/v1/toolMultiDelete", {
    params: {
      id: ids,
    },
  });
};

export const loadFor = function (cust_id, winstage, type, sector) {
  return api.get("/api/v1/toolFor/", {
    params: {
      cust_id: cust_id,
      winstage: winstage,
      type: type,
      sector: sector,
    },
  });
};

export const byName = function (name, cust_id, sortBy, orderBy) {
  return api.get(
    "/api/v1/tools/byName/" +
      name +
      "/" +
      cust_id +
      "/" +
      sortBy +
      "/" +
      orderBy
  );
};

export const findById = function (tool_id) {
  return api.get("/api/v1/tools/byId/" + tool_id);
};

export const updateTool = function (tool_id, toolData) {
  return api.put("/api/v1/updateTool/" + tool_id, toolData);
};
